import { randNumber } from '@ngneat/falso';

import { Operator } from '../../gql';

const operators: Array<Operator> = [Operator.Or, Operator.Xor];

export const mockOperator = (): Operator =>
    operators[randNumber({ min: 0, max: operators.length - 1 })];
